module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/relation_link_child_right-d7fd54d8086a33ea196ff2b279549282.png";